import { SimpleModel } from 'model/SimpleModel';

import { AsyncModel } from './AsyncModel';
import { LogicType } from './LogicType';

export namespace Logic {
  export interface Shape {
    id?: number;
    type?: LogicType;
    [key: string]: unknown;
  }
}

export abstract class Logic<S extends Logic.Shape = Logic.Shape> extends AsyncModel<S> {
  protected constructor(initialData: SimpleModel.Data<S>, type?: LogicType) {
    // If initialData is an object, directly use it, otherwise convert it to a plain object
    const data = initialData instanceof Map ? Object.fromEntries(initialData) : initialData;

    // Create the model with the optional type included
    super(type !== undefined ? { ...data, type } : data);
  }

  getId(): number {
    return this.get('id');
  }

  getType(): LogicType {
    return this.get('type');
  }
}
